import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface GuestsTabState {
  includeAccepted: boolean;
  includeDeclined: boolean;
  includeUndecided: boolean;
  includePlusOnes: boolean;
  includePrimary: boolean;
  includeHasActivities: boolean;
  includeHasNoActivities: boolean;
  // set of guest IDs
  selectedGuests: { [key: string]: boolean };
  searchText: string;
}

const formSlice = createGenericFormSlice({
  name: "guestsTab",
  initialState: {} as SliceState<GuestsTabState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const guestsTabReducer = formSlice.reducer;
export default guestsTabReducer;
